module.exports = __webpack_public_path__ + "img/hot_art.37affb3c.png";